import { render, staticRenderFns } from "./Rola.vue?vue&type=template&id=4110e2a1&"
import script from "./Rola.vue?vue&type=script&lang=js&"
export * from "./Rola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports